import "d3-drag"
import * as clickEvents from "./events/click"
import * as doubleClickEvents from "./events/dblclick"
import * as dragEvents from "./events/drag"
import * as dropEvents from "./events/drop"
import * as contextmenuEvents from "./events/contextmenu"
import * as keyboardEvents from "./events/keyboard"
import * as clipboardEvents from "./events/clipboard"
import { SvgEventHandlers } from "./events/types"

export const configureHandlers = (
  svgElement: SVGSVGElement,
  handlers?: SvgEventHandlers,
  editable?: boolean,
  showSelection?: boolean,
  allowMultiSelect?: boolean,
) => {
  const unregisterMethods = [
    clickEvents.register(svgElement, handlers, editable, showSelection, allowMultiSelect),
    clipboardEvents.register(handlers, editable),
    doubleClickEvents.register(svgElement, handlers),
    dragEvents.register(svgElement, handlers, editable, showSelection, allowMultiSelect),
    dropEvents.register(svgElement, handlers, editable),
    contextmenuEvents.register(svgElement, handlers),
    keyboardEvents.register(handlers, editable),
  ]
  return () => {
    unregisterMethods.forEach((unregisterMethod) => unregisterMethod())
  }
}

export const updateHandlers = (svgElement: SVGSVGElement) => {
  dropEvents.update(svgElement)
}
